import type { Bank } from '@/common/settings.common'

export const UNION_INVESTMENT_NAME = 'Union Investment Management GmbH'

// The Union parent bank is seeded with id 1 on all environments (see PR #483).
export const UNION_BANK_ID = 1

export function isUnionInvestmentBank(bank: Bank): boolean {
  return (bank.name ?? '').trim() === UNION_INVESTMENT_NAME
}

export type UnionBank = Bank & {
  name2: string | null
  name3: string | null

  sapDebtorId: string | null
  businessPartner: string | null
  accountingArea: string | null
  blzNum: string | null
  centralBookingBlock: string | null
  vatNumber: string | null

  autoInvoice: boolean
  active: boolean
  invoiceTemplate: string | null
  parentId: number

  // Per-user contact person — not visible to Union managers (SIB-876).
  contactDetails: {
    contactName: string | null
    contactEmail: string | null
    contactPhone: string | null
  } | null

  // Org-wide contact e-mail, editable by Union managers (SIB-876).
  internalContactEmail: string | null

  associatedEntities: { id: number; name: string }[]
  bankServices: { id: number; serviceCode: string; serviceName: string; price: number }[]

  createdAt: string
  updatedAt: string

  incomplete?: boolean
  missingFields?: string[]
  warnings?: string[]
}
